












import { defineComponent, computed } from '@vue/composition-api';
import { LibraryHelper } from '@getaccept/lib-shared/src/library/helpers/library.helper';

export default defineComponent({
  name: 'TemplateBreadcrumbs',
  props: {
    path: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const directoryBreadcrumbs = computed(() => LibraryHelper.getBreadcrumbsFromPath(props.path));

    const handleClick = (index: number, breadcrumb: string) => {
      if (directoryBreadcrumbs.value[directoryBreadcrumbs.value.length - 1] === breadcrumb) {
        return;
      }

      emit(
        'goto-directory',
        LibraryHelper.getPathFromBreadcrumbs(directoryBreadcrumbs.value, index)
      );
    };

    return { directoryBreadcrumbs, handleClick };
  },
});
